<template>
  <div class="ativity">
    <div class="sort-alltime" v-if="!personHas">
      <div class="sort" v-for="(item, index) in persons" :key="index">
        <span class="num">{{ index + 1 }}</span>
        <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
          <span class="name">{{ item.name }}</span>
        </el-tooltip>
        <span class="all-time">{{ item.time }}h</span>
        <div class="bar">
          <div class="process-static"></div>
          <div class="process-active" :style="{ width: item.persent }"></div>
        </div>
      </div>
    </div>
    <div v-if="personHas" class="more_active">
      <PersonMedia :barData="allActiveList" :more="personHas"></PersonMedia>
    </div>
  </div>
</template>
<script>
import { attendStatistics } from '@/api/log'
import { formatDate } from '@/util/date'
import PersonMedia from '@/views/new-person/PersonMedia.vue'
import { mapGetters } from 'vuex'
export default {
  props: {
    personHas: {
      type: Boolean,
    },
    currenNode: {
      type: [Array, Object],
    },
    activeMore: {
      type: Boolean,
    },
  },
  components: {
    PersonMedia,
  },
  data() {
    return {
      // 人员活跃度统计时间列表数据
      persons: [],
      allPersons: [],
      // 显示更多 柱状图 人员活跃度统计时间列表数据
      allActiveList: {
        barId: 'activeId',
        color: ['#FFD96A'],
        allXData: [],
        allBarData: [],
        lineName: this.$t('ActivityStatisticsTime'),
        unit: 'h',
      },
    }
  },
  methods: {
    // 人员活跃度统计
    attendanceStatics() {
      // formatDate 格式化时间
      let param = {
        ouId: this.currenNode.id,
        logDateBegin: formatDate(this.currenNode.startTime),
        logDateEnd: formatDate(this.currenNode.endTime),
      }
      attendStatistics(param).then(res => {
        if (res.state === 0) {
          this.timeTotal = null
          let personsData = []
          this.persons = []
          if (res.value) {
            if (res.value.attendTime) {
              personsData = res.value.attendTime
              personsData.map(item => {
                this.timeTotal = this.timeTotal + item.time
              })
            }
            this.calcPersent(res.value.attendTime)
          }
        }
      })
    },
    // 计算样式百分比
    calcPersent(data) {
      this.allPersons = []
      this.allActiveList.allXData = []
      this.allActiveList.allBarData = []
      data.map(item => {
        let itempersent = Math.ceil((item.time / this.timeTotal) * 100) + '%'
        this.allActiveList.allXData.push(item.name)
        this.allActiveList.allBarData.push(item.time)
        this.allPersons.push({
          name: item.name,
          time: item.time,
          persent: itempersent,
        })
      })
      if (this.personHas === false && this.allPersons.length >= 6) {
        this.persons = this.allPersons.slice(0, 6)
        this.$emit('changePersonMore', true)
      } else {
        this.persons = this.allPersons
        this.$emit('changePersonMore', false)
      }
    },
  },
  watch: {
    isDefaultTheme: {
      immediate: true,
      handler() {},
    },
    currenNode: {
      handler() {
        this.attendanceStatics()
      },
      deep: true,
    },
    personHas: {
      immediate: true,
      handler(val) {
        if (val) {
          this.attendanceStatics()
        }
      },
    },
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.ativity
  width: 100%
  height: calc(100% - 10px)
  margin 10px auto 0
  .sort-alltime
    height: 100%
    padding 0 16px 2px
    overflow auto
    .sort
      font-size 16px
      margin-top 14px
      display flex
      align-items center
      line-height 30px
      .all-time
        width: 60px
        color: #0E65DD;
      .num
        width 30px
        height 30px
        display inline-block
        line-height 30px
        text-align center
        color #fff
        border-radius 50%
        background rgba(#2096FF, 0.9)
      .name
        width 100px
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
        margin-left 10px
      .bar
        display inline-block
        width 50%
        height 15px
        margin-left 10px
        position relative
        .process-static
          width 100%
          height 15px
          background-size 8px 38px
          background-color #fff
          background-image linear-gradient(90deg, transparent 0px, transparent 4px, #D8D8D8 4px, #D8D8D8 16px, transparent 16px, transparent 24px, #D8D8D8 24px);
        .process-active
          position absolute
          top 0
          height 15px
          background-size 8px 38px
          background-color #006EFF
          // background: linear-gradient( #006EFF 0%, #05F2FD 100%);
          background-image linear-gradient(90deg, transparent 0px, transparent 4px, #fff 4px, #fff 16px, transparent 16px, transparent 24px, #fff 24px);
    .sort:first-child>.num
      background: linear-gradient(0deg, #FFB400 0%, #FFF10C 100%);
    .sort:nth-child(2)>.num
      background: linear-gradient(0deg, #A6A6A6 0%, #E3E3E3 100%);
    .sort:nth-child(3)>.num
      background: linear-gradient(0deg, #DC6D01 0%, #F8AF00 100%);
.more_active
  width: 100%
  height: 100%
  .bar
    width: 90%
// 深色样式
.theme-dark
  .ativity
    .sort-alltime
      .sort
        .all-time
          color: #00E4FF;
        .bar
        .process-static
          background-color #002086
          background-image linear-gradient(90deg, transparent 0px, transparent 4px, #143998 4px, #143998 16px, transparent 16px, transparent 24px, #143998 24px);
        .process-active
          background-color #00c6fe
          background-image linear-gradient(90deg, transparent 0px, transparent 4px, #002086 4px, #002086 16px, transparent 16px, transparent 24px, #002086 24px);
</style>
